<template>
  <div class="wrapper-landing lv2">

    <!-- ─── HERO ─── -->
    <LandingHeroFull
      title="Alles, was dein Baby wirklich braucht. Nichts doppelt. Nichts überflüssig."
      subtitle="Erstelle deine Baby-Wunschliste, teile sie mit deinen Liebsten und bekomme genau das, was ihr braucht."
      buttonText="Wunschliste kostenlos erstellen 👶🏻"
      stickyText="Erstelle eine Liste mit allem, was dein Baby braucht"
      stickyButtonText="Jetzt kostenlos starten 👶🏻"
      socialProofText="Über 100.000 Familien nutzen HelloWish."
      origin="nacimiento"
      listType="baby-registry"
      lang="de-DE"
      :hideSticky="hideSticky"
      :hideLabels="true"
      :coverFullBleed="true"
    >
      <template v-slot:title>
        Alles, was dein Baby wirklich braucht. <em>Nichts doppelt. Nichts überflüssig.</em>
      </template>
      <template v-slot:cover>
        <img
          class="lv2-hero-img lv2-hero-img--nacimiento"
          src="../../assets/img/covers/cover-mujer-embarazada-transparete.webp"
          alt=""
          loading="lazy"
        />
      </template>
    </LandingHeroFull>

    <!-- ─── TRUST: logos ─── -->
    <div class="lv2-trust-bar">
      <p class="lv2-trust-bar__title">Aus jedem Online-Shop hinzufügen</p>
      <div class="lv2-logos-wrapper">
        <div class="lv2-logos-track">
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-amazon.svg" alt="Amazon" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-otto.webp" alt="OTTO" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-hm.svg" alt="H&M" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-zara.svg" alt="Zara" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-c-and-a.webp" alt="C&A" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-babywalz.webp" alt="babywalz" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-sephora.svg" alt="Sephora" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-etsy.svg" alt="Etsy" />
          <img class="lv2-logo-item" src="../../assets/img/logos/zalando-logo.svg" alt="Zalando" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-babyone.webp" alt="BabyOne" />
          <img class="lv2-logo-item" src="../../assets/img/logos/vertbaudet-logo.svg" alt="Vertbaudet" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-babypark.webp" alt="BabyPark" />
          <img class="lv2-logo-item" src="../../assets/img/logos/stokke-logo.svg" alt="Stokke" />
          <!-- duplicado para scroll infinito -->
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-amazon.svg" alt="Amazon" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-otto.webp" alt="OTTO" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-hm.svg" alt="H&M" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-zara.svg" alt="Zara" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-c-and-a.webp" alt="C&A" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-babywalz.webp" alt="babywalz" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-sephora.svg" alt="Sephora" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-etsy.svg" alt="Etsy" />
          <img class="lv2-logo-item" src="../../assets/img/logos/zalando-logo.svg" alt="Zalando" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-babyone.webp" alt="BabyOne" />
          <img class="lv2-logo-item" src="../../assets/img/logos/vertbaudet-logo.svg" alt="Vertbaudet" />
          <img class="lv2-logo-item" src="../../assets/img/logos/logo-af-babypark.webp" alt="BabyPark" />
          <img class="lv2-logo-item" src="../../assets/img/logos/stokke-logo.svg" alt="Stokke" />
        </div>
      </div>
    </div>

    <main>

      <!-- ─── PROBLEMA ─── -->
      <section class="lv2-section lv2-section--gray">
        <div class="lv2-inner lv2-inner--center">
          <h2 class="lv2-title">Was passiert, wenn du keine Wunschliste hast?</h2>
          <div class="lv2-problem-grid">
            <div class="lv2-problem-card">
              <span class="lv2-problem-cross">✗</span>
              <span class="lv2-problem-illus">👶</span>
              <div class="lv2-problem-label">20 Bodys in derselben Größe</div>
              <div class="lv2-problem-sub">Größe 50/56 passt gerade mal sechs Wochen.</div>
            </div>
            <div class="lv2-problem-card">
              <span class="lv2-problem-cross">✗</span>
              <span class="lv2-problem-illus">🧸</span>
              <div class="lv2-problem-label">50 süße Kuscheltiere</div>
              <div class="lv2-problem-sub">Weil alle am liebsten Spielzeug schenken.</div>
            </div>
            <div class="lv2-problem-card">
              <span class="lv2-problem-cross">✗</span>
              <span class="lv2-problem-illus">😳</span>
              <div class="lv2-problem-label">Überraschungen, die niemand braucht</div>
              <div class="lv2-problem-sub">Weil: „Bei uns hat das damals auch gereicht".</div>
            </div>
            <div class="lv2-problem-card">
              <span class="lv2-problem-cross">✗</span>
              <span class="lv2-problem-illus">📦</span>
              <div class="lv2-problem-label">Dinge, die eure Wohnung vollstellen</div>
              <div class="lv2-problem-sub">Nein, diese Babywanne passt nicht in euer Bad.</div>
            </div>
          </div>
        </div>
      </section>

      <!-- ─── CÓMO FUNCIONA ─── -->
      <section class="lv2-section">
        <div class="lv2-inner">
          <h2 class="lv2-title">So funktioniert's</h2>
          <div class="lv2-steps">
            <div class="lv2-step">
              <div class="lv2-step-num">1</div>
              <div class="lv2-step-content">
                <div class="lv2-step-title">Füge alles hinzu, was ihr braucht</div>
                <div class="lv2-step-desc">Vom Kinderwagen über die Babyschale bis zu Bodys, Creme und Fläschchen. Link aus jedem Shop kopieren und einfügen.</div>
              </div>
            </div>
            <div class="lv2-step">
              <div class="lv2-step-num">2</div>
              <div class="lv2-step-content">
                <div class="lv2-step-title">Teile deine Liste mit den Menschen, die dir wichtig sind</div>
                <div class="lv2-step-desc">Mit der Familie, den Freunden, der WhatsApp-Gruppe. Ohne dass sich jemand registrieren oder etwas installieren muss.</div>
              </div>
            </div>
            <div class="lv2-step lv2-step--last">
              <div class="lv2-step-num">3</div>
              <div class="lv2-step-content">
                <div class="lv2-step-title">Bekomme genau das, was ihr euch wünscht</div>
                <div class="lv2-step-desc">Familie und Freunde reservieren Geschenke und markieren sie als gekauft. Deine Liste bleibt immer aktuell. Nichts doppelt.</div>
              </div>
            </div>
          </div>

          <!-- Vídeo en marco de móvil -->
          <div class="lv2-video-box">
            <div class="lv2-phone-frame">
              <div class="lv2-phone-di"></div>
              <div class="lv2-phone-screen">
                <video autoplay muted loop playsinline preload="none">
                  <source src="/landing-babyregistry-en.mp4" type="video/mp4" />
                </video>
              </div>
              <div class="lv2-phone-home"></div>
            </div>
          </div>
        </div>
      </section>

      <!-- ─── PRUEBA SOCIAL ─── -->
      <section class="lv2-section lv2-section--gray">
        <div class="lv2-inner lv2-inner--center">
          <h2 class="lv2-title">Das sagen unsere Familien</h2>
          <div class="lv2-testimonials">
            <div class="lv2-testimonial">
              <span class="lv2-stars">★★★★★</span>
              <p class="lv2-testimonial-text">"Diese App ist perfekt, um die Wunschliste fürs Baby zu erstellen! Es gibt viele Optionen und sie ist sehr intuitiv. Sehr empfehlenswert!"</p>
              <div class="lv2-testimonial-footer">
                <img class="lv2-avatar lv2-avatar--photo" src="../../assets/img/covers/testimonial-marta.jpg" alt="Anna" />
                <div>
                  <div class="lv2-t-name">Anna Schmidt</div>
                  <div class="lv2-t-meta">Berlin</div>
                </div>
              </div>
            </div>
            <div class="lv2-testimonial">
              <span class="lv2-stars">★★★★★</span>
              <p class="lv2-testimonial-text">"Eine super Lösung, um das Thema Geschenke bei der Geburt eines Babys zu vereinfachen! Total einfach zu bedienen und sehr nützlich. Ich empfehle es ❤️."</p>
              <div class="lv2-testimonial-footer">
                <img class="lv2-avatar lv2-avatar--photo" src="../../assets/img/covers/testimonial-estefania.jpg" alt="Julia" />
                <div>
                  <div class="lv2-t-name">Julia Weber</div>
                  <div class="lv2-t-meta">Hamburg</div>
                </div>
              </div>
            </div>
            <div class="lv2-testimonial">
              <span class="lv2-stars">★★★★★</span>
              <p class="lv2-testimonial-text">"Super nützliche und intuitive App, um die Wunschliste fürs Baby zu erstellen. Sehr empfehlenswert."</p>
              <div class="lv2-testimonial-footer">
                <img class="lv2-avatar lv2-avatar--photo" src="../../assets/img/covers/testimonial-ichamar.jpg" alt="Lukas" />
                <div>
                  <div class="lv2-t-name">Lukas Fischer</div>
                  <div class="lv2-t-meta">München</div>
                </div>
              </div>
            </div>
          </div>

          <p class="lv2-testimonials-note">Alle Bewertungen stammen von verifizierten HelloWish-Nutzern. So prüfen wir Bewertungen.</p>

          <div class="lv2-milestone">
            <span class="lv2-milestone-num">Über 1.000.000 passende Geschenke</span>
            <p class="lv2-milestone-text">dank HelloWish.</p>
          </div>
        </div>
      </section>

      <!-- ─── DIFERENCIACIÓN ─── -->
      <section class="lv2-section">
        <div class="lv2-inner">
          <h2 class="lv2-title">Mehr als nur eine Wunschliste</h2>
          <div class="lv2-features">
            <div class="lv2-feature lv2-feature--2">
              <span class="lv2-feature-icon">📉</span>
              <h3 class="lv2-feature-title">Kaufe zum besten Preis</h3>
              <p class="lv2-feature-desc">Wir sagen dir Bescheid, wenn deine Wunschprodukte günstiger werden. Nie wieder eine Preissenkung verpassen.</p>
            </div>
            <div class="lv2-feature lv2-feature--1">
              <span class="lv2-feature-icon">🐷</span>
              <h3 class="lv2-feature-title">Lass dir Geld für die großen Wünsche schenken</h3>
              <p class="lv2-feature-desc">Sammelt gemeinsam für die Babyschale oder den Kinderwagen, oder legt eine Kasse für Windeln an. Jeder gibt, was er möchte.</p>
            </div>
            <div class="lv2-feature lv2-feature--3">
              <span class="lv2-feature-icon">🏷️</span>
              <h3 class="lv2-feature-title">Verpasse kein Angebot</h3>
              <p class="lv2-feature-desc">Sieh Aktionen deiner Lieblingsshops direkt in deiner Wunschliste. HelloWish behält sie für dich im Blick.</p>
            </div>
          </div>
        </div>
      </section>

      <!-- ─── FAQ + CTA FINAL ─── -->
      <section class="lv2-section lv2-section--gray">
        <div class="lv2-inner">
          <h2 class="lv2-title">Häufige Fragen</h2>
          <div class="lv2-faq-list">
            <div
              v-for="(item, i) in faqs"
              :key="i"
              class="lv2-faq-item"
              :class="{ 'lv2-faq-item--open': openFaq === i }"
            >
              <button class="lv2-faq-q" @click="toggleFaq(i)">
                {{ item.q }}
                <span class="lv2-faq-chevron">⌄</span>
              </button>
              <div class="lv2-faq-a">{{ item.a }}</div>
            </div>
          </div>

          <div class="lv2-final-cta" ref="finalCta">
            <h3 class="lv2-final-cta-title">Erstelle die Wunschliste für dein Baby<br>und bekomme genau das, was ihr braucht</h3>
            <p class="lv2-final-cta-sub">Über 100.000 Familien vertrauen HelloWish.</p>
            <button class="lv2-btn-final" @click="scrollToTop">
              Jetzt kostenlos starten 👶🏻
            </button>
          </div>
        </div>
      </section>

    </main>

    <LandingFooter lang="de-DE" />
  </div>
</template>

<script>
import LandingHeroFull from "./components/LandingHeroFull.vue";
import LandingFooter from "./components/LandingFooter.vue";

export default {
  name: "LandingBabyWunschlisteDE",
  metaInfo() {
    return {
      title: "Baby-Wunschliste aus jedem Online-Shop | HelloWish",
      htmlAttrs: { lang: "de" },
      meta: [
        { name: "description", content: "Erstelle deine Baby-Wunschliste mit Produkten aus jedem Online-Shop. Teile sie mit deinen Liebsten und bekomme genau das, was ihr braucht. Kostenlos starten." },
        { name: "robots", content: "noindex" },
      ],
    };
  },
  components: {
    LandingHeroFull,
    LandingFooter,
  },
  data() {
    return {
      openFaq: 0,
      hideSticky: false,
      ioFinal: null,
      faqs: [
        {
          q: "Ist HelloWish wirklich kostenlos?",
          a: "Ja. Wir erhalten eine kleine Provision vom Shop, wenn jemand über deine Liste kauft. Der Preis bleibt für alle gleich. Keine versteckten Kosten.",
        },
        {
          q: "Werden meine Daten verkauft?",
          a: "Nein. HelloWish ist kostenlos, weil wir eine kleine Provision von den Shops erhalten. Nicht, weil wir deine Daten verkaufen. Deine Daten gehören dir. Immer.",
        },
        {
          q: "Wie lange dauert die Einrichtung?",
          a: "In 60 Sekunden ist deine Wunschliste fertig. Du brauchst nur deine E-Mail-Adresse. Keine Kreditkarte, kein Download.",
        },
        {
          q: "Ist meine Liste privat?",
          a: "Nur wer den Link hat, sieht deine Liste. Sie ist nicht über Google auffindbar.",
        },
        {
          q: "Müssen sich Familie und Freunde registrieren, um meine Liste zu sehen?",
          a: "Nein. Wer deinen Link bekommt, sieht die Liste sofort. Ohne Konto, ohne Download. Auch zum Reservieren eines Geschenks ist keine Anmeldung nötig.",
        },
        {
          q: "Können sich mehrere Personen an einem Geschenk beteiligen?",
          a: "Ja. Mit dem digitalen Sparschwein zahlen mehrere zusammen ein und schenken euch gemeinsam etwas Größeres.",
        },
        {
          q: "Wie funktionieren Geldgeschenke?",
          a: "Du legst ein Sparschwein für Ausgaben an, die auf jeden Fall kommen, zum Beispiel Windeln oder die Erstausstattung. Familie und Freunde zahlen ein, so viel sie möchten. Das Geld geht direkt auf dein Konto. Wir behalten nichts davon ein.",
        },
      ],
    };
  },
  mounted() {
    const ctaEl = this.$refs.finalCta;
    if (!ctaEl) return;
    this.ioFinal = new IntersectionObserver(
      ([entry]) => { this.hideSticky = entry.isIntersecting; },
      { threshold: 0 }
    );
    this.ioFinal.observe(ctaEl);
  },
  beforeDestroy() {
    if (this.ioFinal) { this.ioFinal.disconnect(); this.ioFinal = null; }
  },
  methods: {
    toggleFaq(i) {
      this.openFaq = this.openFaq === i ? null : i;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style>
/* ── Hero cover image ────────────────────────────────────── */
.lv2-hero-img {
  width: 100%;
  height: auto;
  display: block;
  mix-blend-mode: multiply;
  animation: fadeInUp 0.6s 0.6s ease both;
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
}
@media (min-width: 1024px) {
  .lv2-hero-img {
    width: clamp(340px, 28vw, 460px);
    -webkit-mask-image:
      linear-gradient(to right,  transparent 0%, black 3%, black 97%, transparent 100%),
      linear-gradient(to bottom, transparent 0%, black 2%, black 97%, transparent 100%);
    mask-image:
      linear-gradient(to right,  transparent 0%, black 3%, black 97%, transparent 100%),
      linear-gradient(to bottom, transparent 0%, black 2%, black 97%, transparent 100%);
    -webkit-mask-composite: source-in;
    mask-composite: intersect;
  }
}

/* ── Nacimiento image: fondo transparente, no multiply ───── */
.lv2-hero-img--nacimiento {
  mix-blend-mode: normal;
}

/* ── Trust bar ───────────────────────────────────────────── */
.lv2-trust-bar {
  background: #312A5E;
  padding: 28px 24px;
  overflow: hidden;
}
.lv2-trust-bar__title {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.65);
  text-align: center;
  margin-bottom: 18px;
}
.lv2-logos-wrapper { overflow: hidden; }
.lv2-logos-track {
  display: flex;
  gap: 32px;
  align-items: center;
  animation: lv2-scroll 22s linear infinite;
  width: max-content;
}
@keyframes lv2-scroll {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
.lv2-logo-item {
  height: 28px;
  width: 100px;
  object-fit: contain;
  flex-shrink: 0;
  filter: brightness(0) invert(1);
  opacity: 0.55;
}

/* ── Secciones comunes ───────────────────────────────────── */
.lv2-section { padding: 72px 24px; }
.lv2-section--gray { background: #F8F9FA; }
@media (min-width: 768px) {
  .lv2-section { padding: 96px 48px; }
}
.lv2-inner { max-width: 680px; margin: 0 auto; }
.lv2-inner--center { text-align: center; }
.lv2-title {
  font-size: clamp(24px, 5vw, 36px);
  font-weight: 800;
  color: #312A5E;
  line-height: 1.2;
  letter-spacing: -0.8px;
  margin-bottom: 36px;
}

/* ── Problema ────────────────────────────────────────────── */
.lv2-problem-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
@media (max-width: 480px) {
  .lv2-problem-grid { grid-template-columns: 1fr; }
}
.lv2-problem-card {
  background: #fff;
  border-radius: 20px;
  padding: 28px 20px;
  border: 1.5px solid #E9ECEF;
  position: relative;
  text-align: center;
}
.lv2-problem-cross {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 24px;
  height: 24px;
  background: #FEE2E2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #991B1B;
  font-weight: 700;
}
.lv2-problem-illus {
  font-size: 48px;
  display: block;
  margin-bottom: 14px;
  line-height: 1;
}
.lv2-problem-label {
  font-size: 16px;
  font-weight: 700;
  color: #312A5E;
  margin-bottom: 6px;
}
.lv2-problem-sub { font-size: 13px; color: #6B7280; line-height: 1.5; }

/* ── Cómo funciona ───────────────────────────────────────── */
.lv2-steps { display: flex; flex-direction: column; margin-bottom: 40px; }
.lv2-step {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  padding-bottom: 36px;
  position: relative;
}
.lv2-step:not(.lv2-step--last)::after {
  content: '';
  position: absolute;
  left: 19px;
  top: 42px;
  bottom: 0;
  width: 2px;
  background: repeating-linear-gradient(
    to bottom,
    #E9ECEF 0,
    #E9ECEF 6px,
    transparent 6px,
    transparent 12px
  );
}
.lv2-step--last { padding-bottom: 0; }
.lv2-step-num {
  width: 40px;
  height: 40px;
  background: #FFCC00;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 800;
  color: #312A5E;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  box-shadow: 0 0 0 6px rgba(255, 204, 0, 0.18);
}
.lv2-step-content { flex: 1; padding-top: 6px; }
.lv2-step-title { font-size: 17px; font-weight: 700; color: #312A5E; margin-bottom: 4px; }
.lv2-step-desc { font-size: 15px; font-weight: 500; color: #4B5563; line-height: 1.6; }

/* ── Video placeholder ───────────────────────────────────── */
.lv2-video-box {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}
.lv2-phone-frame {
  width: 220px;
  background: #1C1C1E;
  border-radius: 48px;
  padding: 14px 10px 18px;
  box-shadow:
    0 0 0 1.5px #3a3a3c,
    inset 0 0 0 1px rgba(255,255,255,0.06),
    0 32px 80px rgba(49, 42, 94, 0.25),
    0 8px 24px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
}
.lv2-phone-di {
  width: 80px;
  height: 20px;
  background: #000;
  border-radius: 20px;
  margin: 0 auto 8px;
}
.lv2-phone-screen {
  border-radius: 30px;
  overflow: hidden;
  aspect-ratio: 9 / 19.5;
  background: #000;
}
.lv2-phone-screen video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.lv2-phone-home {
  width: 90px;
  height: 4px;
  background: rgba(255,255,255,0.25);
  border-radius: 4px;
  margin: 12px auto 0;
}
@media (min-width: 1024px) {
  .lv2-phone-frame { width: 280px; }
}

/* ── Testimonios ─────────────────────────────────────────── */
.lv2-testimonials {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
}
@media (min-width: 1024px) {
  .lv2-testimonials { display: grid; grid-template-columns: repeat(3, 1fr); }
}
.lv2-testimonial {
  background: #fff;
  border-radius: 20px;
  padding: 24px;
  border: 1.5px solid #E9ECEF;
  text-align: left;
}
.lv2-stars { color: #FFCC00; font-size: 16px; letter-spacing: 1px; margin-bottom: 10px; display: block; }
.lv2-testimonial-text {
  font-size: 15px;
  color: #1A1A1A;
  line-height: 1.65;
  margin-bottom: 16px;
  font-style: italic;
}
.lv2-testimonial-footer { display: flex; align-items: center; gap: 10px; }
.lv2-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
}
.lv2-avatar--photo {
  object-fit: cover;
  object-position: top;
}
.lv2-t-name { font-size: 14px; font-weight: 700; color: #312A5E; }
.lv2-t-meta { font-size: 13px; font-weight: 500; color: #4B5563; margin-top: 1px; }
.lv2-testimonials-note { font-size: 12px; color: #6B7280; margin: -18px 0 24px; }
.lv2-milestone {
  background: #312A5E;
  border-radius: 20px;
  padding: 28px 24px;
  margin-bottom: 40px;
}
.lv2-milestone-num {
  font-size: 30px;
  font-weight: 800;
  color: #FFCC00;
  letter-spacing: -1px;
  display: block;
  margin-bottom: 4px;
}
.lv2-milestone-text { font-size: 15px; font-weight: 500; color: rgba(255, 255, 255, 0.88); }

/* ── Features ────────────────────────────────────────────── */
.lv2-features { display: flex; flex-direction: column; gap: 20px; }
@media (min-width: 1024px) {
  .lv2-features { display: grid; grid-template-columns: repeat(3, 1fr); }
}
.lv2-feature { border-radius: 20px; padding: 28px; border: 1.5px solid #E9ECEF; }
.lv2-feature--1 { background: #FFF9E6; border-color: rgba(255, 204, 0, 0.3); }
.lv2-feature--2 { background: #F0EFFF; border-color: rgba(99, 91, 255, 0.2); }
.lv2-feature--3 { background: #E6F4F0; border-color: rgba(16, 185, 129, 0.2); }
.lv2-feature-icon { font-size: 36px; display: block; margin-bottom: 14px; line-height: 1; }
.lv2-feature-title { font-size: 17px; font-weight: 700; color: #312A5E; margin-bottom: 8px; line-height: 1.3; }
.lv2-feature-desc { font-size: 15px; font-weight: 500; color: #4B5563; line-height: 1.6; }

/* ── FAQ ─────────────────────────────────────────────────── */
.lv2-faq-list { display: flex; flex-direction: column; gap: 10px; margin-bottom: 48px; }
.lv2-faq-item { background: #fff; border-radius: 12px; border: 1.5px solid #E9ECEF; overflow: hidden; }
.lv2-faq-q {
  width: 100%;
  background: none;
  border: none;
  outline: none;
  padding: 18px 20px;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 15px;
  font-weight: 600;
  color: #312A5E;
  font-family: inherit;
}
.lv2-faq-q:focus-visible {
  outline: 2px solid #635BFF;
  outline-offset: -2px;
}
.lv2-faq-chevron {
  font-size: 18px;
  color: #635BFF;
  transition: transform 0.25s;
  flex-shrink: 0;
  font-weight: 400;
}
.lv2-faq-item--open .lv2-faq-chevron { transform: rotate(180deg); }
.lv2-faq-a {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
  padding: 0 20px;
  font-size: 15px;
  font-weight: 500;
  color: #4B5563;
  line-height: 1.7;
}
.lv2-faq-item--open .lv2-faq-a { max-height: 240px; padding: 0 20px 20px; }

/* ── CTA final ───────────────────────────────────────────── */
.lv2-final-cta { background: #312A5E; border-radius: 32px; padding: 48px 32px; text-align: center; }
.lv2-final-cta-title {
  font-size: clamp(20px, 4vw, 26px);
  font-weight: 800;
  color: #fff;
  margin-bottom: 10px;
  letter-spacing: -0.5px;
  line-height: 1.3;
}
.lv2-final-cta-sub { font-size: 15px; color: rgba(255, 255, 255, 0.65); margin-bottom: 28px; }
.lv2-btn-final {
  display: inline-block;
  background: #FFCC00;
  color: #312A5E;
  font-family: inherit;
  font-size: 16px;
  font-weight: 800;
  padding: 18px 36px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  letter-spacing: -0.2px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  box-shadow: 0 4px 20px rgba(255, 204, 0, 0.35);
}
.lv2-btn-final:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(255, 204, 0, 0.4); }
.lv2-btn-final:active { transform: translateY(0); }
</style>
